import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { instrumentRoutePerformance } from '@sentry/ember';
import StoreService from 'scaleflow/services/store';

class SettingsAgentsAgentRoute extends Route {
  @service declare store: StoreService;

  model({ agent_id }: { agent_id: string }) {
    return this.store.findRecord('agent', agent_id);
  }
}

export default instrumentRoutePerformance(SettingsAgentsAgentRoute);
